<script>
import ModalContainer from '@sections/ModalContainer';
import TkoComponent from '@sections/TkoComponent';
import { useHybrid } from '@/platform/composables/useHybrid';

export default {
  components: {
    ModalContainer,
    TkoComponent,
  },
  setup() {
    const { isHybridReady } = useHybrid();
    return {
      isHybridReady,
    };
  },
};
</script>
<template>
  <div v-if="isHybridReady">
    <!-- legacy TKO components -->
    <TkoComponent name="section-modals" />
    <ModalContainer />
  </div>
</template>
